<template>
    <component :is="componentEntity" v-if="isComponentNameExist" :singlePage="singlePage" />
    <div v-else>
        <p style="color:red">Error: 模板不存在,后台配置的vueTemplateName: {{ singlePage!.vueTemplateName! }} 名称在前端不存在！</p>
    </div>
</template>


<script setup lang="ts" name="SinglePageIndex">
    import { ref, shallowRef } from 'vue'
    import cmsUtils from '~/utils/cmsUtils'

    const componentEntity = shallowRef()
    const isComponentNameExist = ref(true)

    // 获取 singlePage 数据
    const route = useRoute()
    const url = route.path.split('/').at(-1)!.replace('.html', '')
    const cmsInfo = await cmsUtils.getCmsInfo()
    const singlePage =  cmsUtils.getSinglePageByUrl(url,cmsInfo)
    isComponentNameExist.value = cmsUtils.checkComponentNameExist(singlePage!.vueTemplateName ? singlePage!.vueTemplateName : 'SinglePageDefault')
    if (isComponentNameExist.value) {
        if (singlePage!.vueTemplateName) {
            // 这里能使用singlePage!.vueTemplateName变量，是因为我们在nuxt.config.ts 中，components中，设置了global:true
            componentEntity.value = resolveComponent(singlePage!.vueTemplateName)
        } else {
            componentEntity.value = resolveComponent('SinglePageDefault')
        }
    }

  const fullUrl = (cmsInfo.website.https?"https://":"http://") +  cmsInfo.website.domain + route.fullPath;
  const imageUrl = "https://images.leaflypackaging.com/profile/upload/2025/11/24/1_20251124233036A077.webp"
    useHead({
        htmlAttrs: {
            lang: 'en'
        },
        title:  singlePage?.title,
        meta: [
            { name: 'title', content: singlePage?.title },
            { name: 'keywords', content: singlePage?.keywords },
            { name: 'description', content: singlePage?.description },
            // Open Graph
            { property: 'og:title', content: singlePage!.title },
            { property: 'og:description', content: singlePage!.description },
            { property: 'og:url', content: fullUrl },
            { property: 'og:image', content: imageUrl },
            { property: 'og:site_name', content: cmsInfo.website.title || 'The Leafly Packaging Company' },
            { property: 'og:type', content: 'website' },
            { property: 'og:locale', content: 'en_US' },
            // Twitter Card
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: singlePage!.title },
            { name: 'twitter:description', content: singlePage!.description },
        ],
        link: [
            { rel: 'canonical', href: (cmsInfo.website.https?"https://":"http://") + cmsInfo.website.domain + route.path.replace(".html","") }
        ]
    })
</script>
<style scoped lang='scss'></style>